import { Box } from "@mui/material";
import { UseFormReturn } from "react-hook-form";

import { testDriveOptions } from "../utils/selectOptions";
import useResponsive from "@/hooks/useResponsive";

import CustomRadioGroup from "@/components/RHFcomponents/CustomRadioGroup";
import { FieldLabel, FormTitle } from "../components";
import TextArea from "@/components/RHFcomponents/TextArea";
import { getRadioGroupTestDriveStyles } from "./styles";
import { CustomRadioGroupOption } from "@/components/RHFcomponents/CustomRadioGroup/types";

interface IProp {
  methods: UseFormReturn<IFleetInquiryForm, unknown, undefined>;
}

const FormThirdStep: React.FC<IProp> = ({ methods: { control } }) => {
  const isMobile = useResponsive("down", "sm");

  return (
    <>
      <FormTitle
        title="What are your tracking requirements"
        subtitle="Let us know your unique tracking requirements."
        withHeader
      />

      <Box display="flex" flexDirection="column" gap={{ xs: 4, md: 5 }}>
        <Box sx={getRadioGroupTestDriveStyles(isMobile)}>
          <FieldLabel
            label="Preferred test drive duration"
            mb={{ xs: 1, md: 2 }}
          />
          <CustomRadioGroup
            name="timeTable"
            control={control}
            options={testDriveOptions as CustomRadioGroupOption[]}
          />
        </Box>

        <Box>
          <FieldLabel
            label="Describe any specific tracking features or challenges you'd like our solution to address."
            mb={2}
          />
          <TextArea
            name="customFeatures"
            control={control}
            placeholder="Describe here..."
          />
        </Box>
      </Box>
    </>
  );
};

export default FormThirdStep;
